import { useQuery } from '@tanstack/react-query';
import { PdfDocumentProxy } from '../types';
import { loadPdfDocument } from '../services/pdfDocumentService';
import { loadPdfJs } from '../services/pdfjsLoader';

const QUERY_KEYS = {
  runtime: ['pdf-editor', 'runtime'] as const,
  document: (fileUrl: string) => ['pdf-editor', 'document', fileUrl] as const,
};

export const usePdfRuntimeQuery = () =>
  useQuery({
    queryKey: QUERY_KEYS.runtime,
    queryFn: loadPdfJs,
    staleTime: Number.POSITIVE_INFINITY,
    gcTime: Number.POSITIVE_INFINITY,
  });

export const usePdfDocumentQuery = (fileUrl: string | null) =>
  useQuery<PdfDocumentProxy, Error>({
    queryKey: QUERY_KEYS.document(fileUrl ?? ''),
    enabled: Boolean(fileUrl),
    queryFn: async () => {
      if (!fileUrl) throw new Error('Missing PDF file URL');
      return loadPdfDocument(fileUrl);
    },
    staleTime: 60_000,
    gcTime: 10 * 60_000,
  });
